<template>
  <section class="school-new-schedule">
    <div class="main-title">
      <h2 v-html="title" />
    </div>

    <div
      v-if="!activeProfClass"
      ref="buttonsElem"
      class="school-new-schedule__buttons"
    >
      <button
        v-for="(button, index) in buttons"
        :key="index"
        :class="['m-btn', { active: activeButtonIndex === index }]"
        @click="setActive(index)"
      >
        {{ button.title }}
      </button>
    </div>

    <div class="school-new-schedule__content">
      <div class="schedule__wrapper">
        <h6>
          пример расписания уроков на&nbsp;2024–2025
          учебный год&nbsp;для&nbsp;{{ pageClass || 5 }}&nbsp;класса
        </h6>

        <div class="schedule">
          <span class="schedule__time" />
          <span class="schedule__day">понедельник</span>
          <span class="schedule__day">вторник</span>
          <span class="schedule__day">среда</span>
          <span class="schedule__day">четверг</span>
          <span class="schedule__day">пятница</span>
          <template
            v-for="(row, rowIdx) in schedule"
          >
            <span :key="rowIdx" class="schedule__time">
              {{ row.time }}
            </span>
            <span
              v-for="(col, colIdx) in row.subjects"
              :key="`${rowIdx}-${colIdx}`"
              :class="`schedule__subject schedule__subject--${col.color}`"
              @click="openModal(MODAL_TYPES.plan)"
              v-html="col.title"
            />
          </template>
        </div>
      </div>

      <div
        v-if="(pageClass || ceny2Page) && activeButtonIndex === 0"
        :class="`school-new-schedule__block block block--half block--${currentButton.className}`"
      >
        <h4>
          получите <span>бесплатный</span> доступ
          к&nbsp;платформе на&nbsp;<span>7&nbsp;дней</span>
        </h4>

        <div class="block__cheap">
          <span>10 000 материалов</span>
          <span>записи уроков бесплатно</span>
        </div>

        <button
          class="m-btn"
          @click="openModal(MODAL_TYPES.demo)"
        >
          перейти на платформу
        </button>
      </div>
      <div
        v-else
        :class="[`school-new-schedule__block block block--${currentButton.className}`, {
          'block--half': !activeProfClass,
        }]"
      >
        <div class="block__cheap">
          <span>{{ currentButton.block.cheap }}</span>
          <span>5-11 класс</span>
        </div>

        <h5>доп. занятия</h5>
        <p>поступить может каждый <span>без&nbsp;вступительных</span> экзаменов</p>

        <ul>
          <li
            v-for="(item, idx) in currentButton.block.list"
            :key="idx"
            v-html="item"
          />
        </ul>

        <button
          v-if="activeProfClass"
          class="m-btn"
          @click="openModal(MODAL_TYPES.plan)"
        >
          скачать учебный план
        </button>
        <button
          v-else-if="ceny2Page"
          class="m-btn"
          @click="openModalWithComment(MODAL_TYPES.moreProfil)"
        >
          скачать учебный план
        </button>
        <nuxt-link
          v-else
          :to="currentButton.block.link"
          class="m-btn"
        >
          узнать больше о профиле
        </nuxt-link>
      </div>
    </div>

    <div
      v-if="activeProfClass"
      class="school-new-schedule__prof-class-banner"
    >
      <h5 v-if="activeProfClass === 'fizmat'">
        <span>как&nbsp;попасть на&nbsp;физмат?</span>
        куда поступать? кем&nbsp;стать? отвечаем на&nbsp;консультации
      </h5>
      <h5 v-else-if="activeProfClass === 'language'">
        <span>как&nbsp;попасть на лингвистический?</span>
        куда поступать? отвечаем на&nbsp;консультации
      </h5>
      <h5 v-else-if="activeProfClass === 'gym'">
        <span>как&nbsp;попасть в гуманитарный класс?</span>
        кем&nbsp;стать? отвечаем на&nbsp;консультации
      </h5>
      <h5 v-else-if="activeProfClass === 'econ'">
        <span>как&nbsp;попасть в&nbsp;соц. эконом класс?</span>
        кем&nbsp;стать? отвечаем на&nbsp;консультации
      </h5>
      <button
        class="m-btn"
        @click="openModal(MODAL_TYPES.profClassConsult)"
      >
        записаться на консультацию
      </button>
    </div>

    <div
      v-else
      class="school-new-schedule__banner"
    >
      <h5>поможем с&nbsp;выбором <span>будущей профессии</span> вашего ребенка</h5>
      <button
        class="m-btn"
        @click="openModal(MODAL_TYPES.proforientacia)"
      >
        бесплатная консультация
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../common/AppHeader/data';

const BUTTON = {
  base: 'base',
  fizmat: 'fizmat',
  gym: 'gym',
  language: 'language',
  econ: 'econ',
};

const scheduleEmptyLine = [
  { title: '', color: 'grey' },
  { title: '', color: 'grey' },
  { title: '', color: 'grey' },
  { title: '', color: 'grey' },
  { title: '', color: 'grey' },
];

const scheduleBigChange = {
  time: '11:20-11:40',
  subjects: [
    { title: 'Большая перемена', color: 'grey' },
    { title: 'Большая перемена', color: 'grey' },
    { title: 'Большая перемена', color: 'grey' },
    { title: 'Большая перемена', color: 'grey' },
    { title: 'Большая перемена', color: 'grey' },
  ],
};

const defaultSchedule = [
  {
    time: '09:00-09:40',
    subjects: [
      { title: 'Химия', color: 'pink' },
      { title: '', color: 'grey' },
      { title: 'Химия', color: 'pink' },
      { title: 'География', color: 'pink' },
      { title: 'Физика', color: 'blue' },
    ],
  },
  {
    time: '09:50-10:30',
    subjects: [
      { title: 'Литература', color: 'orange' },
      { title: 'География', color: 'pink' },
      { title: 'Алгебра', color: 'blue' },
      { title: 'Физ-ра', color: 'violet' },
      { title: 'Технология', color: 'violet' },
    ],
  },
  {
    time: '10:40-11:20',
    subjects: [
      { title: 'Русский язык', color: 'orange' },
      { title: 'Биология', color: 'pink' },
      { title: 'Геометрия', color: 'blue' },
      { title: 'История', color: 'red' },
      { title: 'Литература', color: 'orange' },
    ],
  },
  scheduleBigChange,
  {
    time: '11:40-12:20',
    subjects: [
      { title: 'Русский язык', color: 'orange' },
      { title: 'История', color: 'red' },
      { title: 'Обществознание', color: 'red' },
      { title: 'Биология', color: 'pink' },
      { title: 'Английский язык', color: 'green' },
    ],
  },
  {
    time: '12:30-13:10',
    subjects: [
      { title: 'Алгебра', color: 'blue' },
      { title: 'Музыка', color: 'violet' },
      { title: 'Английский язык', color: 'green' },
      { title: 'Русский язык', color: 'orange' },
      { title: 'Алгебра', color: 'blue' },
    ],
  },
  {
    time: '13:20-14:00',
    subjects: [
      { title: 'Английский язык', color: 'green' },
      { title: 'Физика', color: 'blue' },
      { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
      { title: '', color: 'grey' },
      { title: 'Геометрия', color: 'blue' },
    ],
  },
  {
    time: '14:10-14:50',
    subjects: [
      { title: '', color: 'grey' },
      { title: '', color: 'grey' },
      { title: 'Информатика', color: 'blue' },
      { title: '', color: 'grey' },
      { title: 'ОБ и защиты Родины', color: 'red' },
    ],
  },
];

const schedule5Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'География', color: 'pink' },
        { title: 'Биология', color: 'pink' },
        { title: 'Математика', color: 'blue' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Математика', color: 'blue' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'Математика', color: 'blue' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Математика', color: 'blue' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Математика', color: 'blue' },
        { title: 'Музыка', color: 'violet' },
        { title: 'Английский язык', color: 'green' },
        { title: 'ОДНКНР', color: 'red' },
        { title: 'Русский язык', color: 'orange' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Английский язык', color: 'green' },
        { title: 'История', color: 'red' },
        { title: 'Английский язык', color: 'green' },
        { title: 'ИЗО', color: 'violet' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Литература', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: '', color: 'grey' },
        { title: 'История', color: 'red' },
        { title: '', color: 'grey' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: scheduleEmptyLine,
    },
    {
      time: '14:10-14:50',
      subjects: scheduleEmptyLine,
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule6Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Математика', color: 'blue' },
        { title: 'Литература', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'Музыка', color: 'violet' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'История', color: 'red' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Биология', color: 'pink' },
        { title: 'Математика', color: 'blue' },
        { title: 'ОДНКНР', color: 'red' },
        { title: '', color: 'grey' },
        { title: 'Математика', color: 'blue' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'География', color: 'pink' },
        { title: 'История', color: 'red' },
        { title: 'Математика', color: 'blue' },
        { title: 'Математика', color: 'blue' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Английский язык', color: 'green' },
        { title: 'ИЗО', color: 'violet' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Обществознание', color: 'red' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
        { title: 'Технология', color: 'violet' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: scheduleEmptyLine,
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule7Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'Музыка', color: 'violet' },
        { title: 'Информатика', color: 'blue' },
        { title: 'Биология', color: 'pink' },
        { title: 'История', color: 'red' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Литература', color: 'orange' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Русский язык', color: 'orange' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Литература', color: 'orange' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'ИЗО', color: 'violet' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Обществознание', color: 'red' },
        { title: 'Физика', color: 'blue' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Физика', color: 'blue' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'История', color: 'red' },
        { title: 'География', color: 'pink' },
        { title: 'География', color: 'pink' },
        { title: 'Технология', color: 'violet' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Геометрия', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'Геометрия', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: [
        { title: 'География', color: 'pink' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
      ],
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule8Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Химия', color: 'pink' },
        { title: 'География', color: 'pink' },
        { title: 'Химия', color: 'pink' },
        { title: 'География', color: 'pink' },
        { title: '', color: 'grey' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Литература', color: 'orange' },
        { title: '', color: 'grey' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Физ-ра', color: 'violet' },
        { title: '', color: 'grey' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'Биология', color: 'pink' },
        { title: 'Геометрия', color: 'blue' },
        { title: 'История', color: 'red' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'История', color: 'red' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Биология', color: 'pink' },
        { title: 'Английский язык', color: 'green' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Алгебра', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'Обществознание', color: 'red' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Английский язык', color: 'green' },
        { title: 'Физика', color: 'blue' },
        { title: 'Английский язык', color: 'green' },
        { title: '', color: 'grey' },
        { title: 'Геометрия', color: 'blue' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: [
        { title: 'Физика', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'ОБ и защиты Родины', color: 'red' },
      ],
    },
  ],
  [BUTTON.base]: [
    { title: '', color: 'grey' },
    { title: '', color: 'grey' },
    { title: 'Информатика', color: 'blue' },
    { title: '', color: 'grey' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: 'Информатика', color: 'blue' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Информатика', color: 'blue' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: 'Информатика', color: 'blue' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: 'Информатика', color: 'blue' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule9Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Биология', color: 'pink' },
        { title: 'Химия', color: 'pink' },
        { title: 'Биология', color: 'pink' },
        { title: 'История', color: 'red' },
        { title: 'Английский язык', color: 'green' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Английский язык', color: 'green' },
        { title: 'Физика', color: 'blue' },
        { title: 'Английский язык', color: 'green' },
        { title: 'Технология', color: 'violet' },
        { title: 'ОБ и защиты Родины', color: 'red' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Алгебра', color: 'blue' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Литература', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Геометрия', color: 'blue' },
        { title: 'Георграфия', color: 'pink' },
        { title: 'Химия', color: 'pink' },
        { title: 'География', color: 'pink' },
        { title: 'Геометрия', color: 'blue' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Русский язык', color: 'orange' },
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Русский язык', color: 'orange' },
        { title: '', color: 'grey' },
        { title: 'Обществознание', color: 'red' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Литература', color: 'orange' },
        { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
        { title: 'Физика', color: 'blue' },
        { title: 'Физика', color: 'blue' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: [
        { title: 'История', color: 'red' },
        { title: 'Информатика', color: 'blue' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
        { title: '', color: 'grey' },
      ],
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule10Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Биология', color: 'pink' },
        { title: 'Георграфия', color: 'pink' },
        { title: 'Английский язык', color: 'green' },
        { title: '', color: 'orange' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'История', color: 'red' },
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Физика', color: 'blue' },
        { title: 'История', color: 'red' },
        { title: 'Обществознание', color: 'red' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Английский язык', color: 'green' },
        { title: 'Литература', color: 'orange' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Информатика', color: 'blue' },
        { title: 'Английский язык', color: 'green' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Алгебра', color: 'blue' },
        { title: 'Физика', color: 'blue' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Геометрия', color: 'blue' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Геометрия', color: 'blue' },
        { title: 'Химия', color: 'pink' },
        { title: 'Обществознание', color: 'red' },
        { title: 'Геометрия', color: 'blue' },
        { title: 'Русский язык', color: 'orange' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Литература', color: 'orange' },
        { title: '', color: 'grey' },
        { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
        { title: '', color: 'grey' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: [
        { title: 'Обществознание', color: 'red' },
        { title: '', color: 'grey' },
        { title: 'ОБ и защиты Родины', color: 'red' },
        { title: '', color: 'grey' },
        { title: 'Обществознание', color: 'red' },
      ],
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

const schedule11Class = {
  main: [
    {
      time: '09:00-09:40',
      subjects: [
        { title: 'Геометрия', color: 'blue' },
        { title: 'История', color: 'red' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Обществознание', color: 'red' },
      ],
    },
    {
      time: '09:50-10:30',
      subjects: [
        { title: 'Вероятность и&nbsp;статистика', color: 'blue' },
        { title: 'Русский язык', color: 'orange' },
        { title: 'Алгебра', color: 'blue' },
        { title: 'Геометрия', color: 'blue' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    {
      time: '10:40-11:20',
      subjects: [
        { title: 'Биология', color: 'pink' },
        { title: 'География', color: 'pink' },
        { title: 'Обществознание', color: 'red' },
        { title: 'История', color: 'red' },
        { title: 'Алгебра', color: 'blue' },
      ],
    },
    scheduleBigChange,
    {
      time: '11:40-12:20',
      subjects: [
        { title: 'Химия', color: 'pink' },
        { title: 'Литература', color: 'orange' },
        { title: 'ОБ и защиты Родины', color: 'red' },
        { title: 'Физ-ра', color: 'violet' },
        { title: '', color: 'grey' },
      ],
    },
    {
      time: '12:30-13:10',
      subjects: [
        { title: 'Английский язык', color: 'green' },
        { title: 'Информатика', color: 'blue' },
        { title: 'Геометрия', color: 'blue' },
        { title: 'Литература', color: 'orange' },
        { title: 'Литература', color: 'orange' },
      ],
    },
    {
      time: '13:20-14:00',
      subjects: [
        { title: 'Физика', color: 'blue' },
        { title: 'Физ-ра', color: 'violet' },
        { title: 'Английский язык', color: 'green' },
        { title: '', color: 'grey' },
        { title: 'Английский язык', color: 'green' },
      ],
    },
    {
      time: '14:10-14:50',
      subjects: scheduleEmptyLine,
    },
  ],
  [BUTTON.base]: scheduleEmptyLine,
  [BUTTON.fizmat]: [
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-blue' },
    { title: 'Проф. программа', color: 'additional-blue' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.gym]: [
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
    { title: 'Soft skills', color: 'additional-orange' },
    { title: 'Проф. программа', color: 'additional-orange' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.language]: [
    { title: 'Проф. программа', color: 'additional-green' },
    { title: 'Soft skills', color: 'additional-green' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-green' },
    { title: '', color: 'grey' },
  ],
  [BUTTON.econ]: [
    { title: 'Проф. программа', color: 'additional-red' },
    { title: 'Soft skills', color: 'additional-red' },
    { title: '', color: 'grey' },
    { title: 'Проф. программа', color: 'additional-red' },
    { title: '', color: 'grey' },
  ],
};

export default {
  name: 'SchoolNewSchedule',
  props: {
    activeProfClass: {
      type: String,
      default: null,
    },
    pageClass: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    activeButtonIndex: 0,
    MODAL_TYPES,
  }),
  computed: {
    buttons() {
      return [
        ...(this.pageClass || this.ceny2Page) ? [{
          id: BUTTON.base,
          title: 'базовая программа',
          className: 'base',
          additionalScheduleSubjects: scheduleEmptyLine,
        }] : [],
        {
          id: BUTTON.fizmat,
          title: 'физико-математический',
          className: 'blue',
          block: {
            cheap: '+ 2 часа/нед',
            list: [
              'ментальная арифметика',
              'геометрия на&nbsp;плоскости и&nbsp;в&nbsp;пространстве',
              'программирование на Python, Construct&nbsp;3, Roblox',
              'личностное развитие: soft skills',
              'подготовка к&nbsp;огэ/егэ по&nbsp;выбранным предметам в&nbsp;9&nbsp;и&nbsp;11&nbsp;классе',
            ],
            link: '/online-school/fiziko-matematicheskij',
          },
          additionalScheduleSubjects: [
            { title: 'Физика', color: 'additional-blue' },
            { title: 'Информатика', color: 'additional-blue' },
            { title: '', color: 'grey' },
            { title: 'Математика', color: 'additional-blue' },
            { title: '', color: 'grey' },
          ],
        },
        {
          id: BUTTON.gym,
          title: 'гуманитарный',
          className: 'orange',
          block: {
            cheap: '+ 2 часа/нед',
            list: [
              'литературный кружок «Между&nbsp;строк»',
              'мастер слова: развитие речи и&nbsp;обогащение словарного запаса',
              'развитие творческого потенциала',
              'личностное развитие: soft skills',
              'подготовка к&nbsp;огэ/егэ по&nbsp;выбранным предметам в&nbsp;9&nbsp;и&nbsp;11&nbsp;классе',
            ],
            link: '/online-school/gumanitarnyj',
          },
          additionalScheduleSubjects: [
            { title: 'Литература', color: 'additional-orange' },
            { title: 'Обществознание', color: 'additional-orange' },
            { title: '', color: 'grey' },
            { title: 'Русский язык', color: 'additional-orange' },
            { title: '', color: 'grey' },
          ],
        },
        {
          id: BUTTON.language,
          title: 'лингвистический',
          className: 'green',
          block: {
            cheap: '+ 2 часа/нед',
            list: [
              '«I can!» —&nbsp;развитие навыков владения английским языком',
              '«Aventuras en español» — приключения в&nbsp;испанском языке',
              'личностное развитие: soft skills',
              'подготовка к&nbsp;огэ/егэ по&nbsp;выбранным предметам в&nbsp;9&nbsp;и&nbsp;11&nbsp;классе',
            ],
            link: '/online-school/lingvisticheskij',
          },
          additionalScheduleSubjects: [
            { title: 'Иностранный язык', color: 'additional-green' },
            { title: 'Иностранный язык', color: 'additional-green' },
            { title: '', color: 'grey' },
            { title: 'Иностранный язык', color: 'additional-green' },
            { title: '', color: 'grey' },
          ],
        },
        {
          id: BUTTON.econ,
          title: 'соц. экономический',
          className: 'red',
          block: {
            cheap: '+ 2 часа/нед',
            list: [
              'финансовая грамотность',
              'экономика вокруг нас',
              'основы дизайна и создания эффективных презентаций',
              'личностное развитие: soft skills',
              'подготовка к&nbsp;огэ/егэ по&nbsp;выбранным предметам в&nbsp;9&nbsp;и&nbsp;11&nbsp;классе',
            ],
            link: '/online-school/socialno-ekonomicheskij',
          },
          additionalScheduleSubjects: [
            { title: 'Фин. грамотность', color: 'additional-red' },
            { title: 'Обществознание', color: 'additional-red' },
            { title: '', color: 'grey' },
            { title: 'Экономика', color: 'additional-red' },
            { title: '', color: 'grey' },
          ],
        },
      ];
    },
    currentButton() {
      if (this.activeProfClass === 'fizmat') return this.buttons[0];
      if (this.activeProfClass === 'gym') return this.buttons[1];
      if (this.activeProfClass === 'language') return this.buttons[2];
      if (this.activeProfClass === 'econ') return this.buttons[3];

      return this.buttons[this.activeButtonIndex];
    },
    schedule() {
      let baseSchedule = defaultSchedule;
      let additionalSchedule = this.currentButton.additionalScheduleSubjects;

      if (this.pageClass === 5 || this.ceny2Page) {
        baseSchedule = schedule5Class.main;
        additionalSchedule = schedule5Class[this.currentButton.id];
      }

      if (this.pageClass === 6) {
        baseSchedule = schedule6Class.main;
        additionalSchedule = schedule6Class[this.currentButton.id];
      }

      if (this.pageClass === 7) {
        baseSchedule = schedule7Class.main;
        additionalSchedule = schedule7Class[this.currentButton.id];
      }

      if (this.pageClass === 8) {
        baseSchedule = schedule8Class.main;
        additionalSchedule = schedule8Class[this.currentButton.id];
      }

      if (this.pageClass === 9) {
        baseSchedule = schedule9Class.main;
        additionalSchedule = schedule9Class[this.currentButton.id];
      }

      if (this.pageClass === 10) {
        baseSchedule = schedule10Class.main;
        additionalSchedule = schedule10Class[this.currentButton.id];
      }

      if (this.pageClass === 11) {
        baseSchedule = schedule11Class.main;
        additionalSchedule = schedule11Class[this.currentButton.id];
      }

      return [
        ...baseSchedule,
        { time: '15:00-18:00', subjects: additionalSchedule },
      ];
    },
    title() {
      if (this.pageClass) {
        // eslint-disable-next-line max-len,vue/max-len
        return `вся&nbsp;программа обучения <br> <span>для&nbsp;${this.pageClass}&nbsp;класса в&nbsp;онлайн-школе</span>`;
      }

      if (this.activeProfClass) {
        return 'углубленное изучение профиля<span> через&nbsp;внеклассные занятия</span>';
      }

      return 'образовательные программы <span>для&nbsp;вашего будущего</span>';
    },
    ceny2Page() {
      return this.$route?.name === 'online-school-ceny-2'
        || this.$route?.name === 'online-school-ceny-dubai'
        || this.$route?.name === 'online-school-ceny-3';
    },
  },
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
      setModalComment: 'setModalComment',
    }),

    openModalWithComment(modalType) {
      this.openModal(modalType);
      this.setModalComment(this.currentButton.title);
    },

    setActive(index) {
      this.activeButtonIndex = index;

      // при клике на первый скроллить вперед
      if (index === 0) {
        this.$refs.buttonsElem.scrollLeft = 0;
      }
      // при клике на последний, скроллить до конца
      if (index === this.buttons.length - 1) {
        this.$refs.buttonsElem.scrollLeft = this.$refs.buttonsElem.scrollWidth;
      }
    },
  },
};
</script>

<style scoped lang="scss">

.school-new-schedule {
  position: relative;

  .main-title {
    max-width: calc(var(--scale) * 1500);
    margin-bottom: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
    }
  }

  &__buttons {
    margin-bottom: calc(var(--scale) * 24);
    display: flex;
    gap: calc(var(--scale) * 8);

    overflow-x: auto;
    width: calc(100% + var(--scale) * 80);
    margin-left: calc(-1 * var(--scale) * 40);
    padding: 0 calc(var(--scale) * 40);
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      display: none;
    }

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 16);
      gap: calc(var(--scale) * 4);
      width: calc(100% + var(--scale) * 32);
      margin-left: calc(-1 * var(--scale) * 16);
      padding: 0 calc(var(--scale) * 16);
    }

    @include media-down($size-mobile) {
      width: calc(100% + calc(var(--scale) * 24));
      margin-left: calc(-1 * var(--scale) * 12);
      padding-inline: calc(var(--scale) * 12);
    }

    button {
      padding: calc(var(--scale) * 32) calc(var(--scale) * 54);
      background-color: #FFFFFF;
      border-radius: calc(var(--scale) * 200);
      transition: 200ms;

      font-family: inherit;
      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #A7ABAC;
      white-space: nowrap;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 16) calc(var(--scale) * 22);
        font-size: calc(var(--scale) * 18);
        white-space: nowrap;
      }

      &:hover {
        color: #5237E6;
      }

      &.active {
        background-color: #5237E6;
        color: #FFFFFF;
      }
    }
  }

  &__content  {
    display: flex;
    gap: calc(var(--scale) * 20);
    margin-bottom: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      flex-direction: column;
      gap: calc(var(--scale) * 7);
      margin-bottom: calc(var(--scale) * 8);
    }

    .schedule__wrapper {
      width: 100%;
      background: #FCFCFC;
      border-radius: calc(var(--scale) * 60);
      padding: calc(var(--scale) * 32) calc(var(--scale) * 30) calc(var(--scale) * 40) calc(var(--scale) * 40);

      @include media-down($size-tablet) {
        border-radius: calc(var(--scale) * 32);
        padding: calc(var(--scale) * 20) 0 calc(var(--scale) * 40);
        overflow: hidden;
      }

      h6 {
        margin-bottom: calc(var(--scale) * 20);
        max-width: calc(var(--scale) * 700);
        margin-inline: auto;

        font-weight: 500;
        font-size: calc(var(--scale) * 32);
        line-height: 110%;
        text-align: center;
        color: #02120F;

        @include media-down($size-tablet) {
          max-width: calc(var(--scale) * 334);
          font-size: calc(var(--scale) * 20);
          letter-spacing: -0.02em;
        }
      }
    }
  }

  &__block {
    flex-shrink: 0;
    width: calc(var(--scale) * 601);

    @include media-down($size-tablet) {
      width: 100%;
    }
  }

  .schedule {
    display: grid;
    grid-template-columns: calc(var(--scale) * 100) repeat(5, calc(var(--scale) * 192));
    row-gap: calc(var(--scale) * 8);
    column-gap: calc(var(--scale) * 16);
    align-items: center;

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 16);
      padding-bottom: calc(var(--scale) * 16);
      margin-bottom: calc(-1 * var(--scale) * 16);
      width: 100%;
      overflow-x: auto;
    }

    .schedule__day {
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      text-align: center;
      color: #A7ABAC;
    }

    .schedule__time {
      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      text-align: right;
      color: #02120F;
    }

    .schedule__subject {
      display: grid;
      place-content: center;
      border-radius: calc(var(--scale) * 16);
      height: calc(var(--scale) * 50);
      padding-inline: calc(var(--scale) * 20);
      width: 100%;

      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      color: #FFFFFF;
      line-height: 130%;
      text-align: center;

      &--pink {
        background-color: #FFCEE2;
        color: #8D176C;
      }

      &--blue {
        background-color: #CEF9FF;
        color: #0A4183;
      }

      &--orange {
        background-color: #FFF0D1;
        color: #FF5319;
      }

      &--violet {
        background-color: #E6CEFF;
        color: #5237E6;
      }

      &--green {
        background-color: #D1FAD8;
        color: #01410D;
      }

      &--red {
        background-color: #FFCDCF;
        color: #8D1717;
      }

      &--grey {
        background-color: #ECEDF0;
        color: #02120F;
      }

      &--additional-blue {
        background-color: #0B72BE;
      }

      &--additional-orange {
        background-color: #FF9C12;
      }

      &--additional-green {
        background-color: #22AE73;
      }

      &--additional-red {
        background-color: #EE3A41;
      }
    }
  }

  .block {
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: calc(var(--scale) * 20);
    background-size: 100% 100%;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      height: calc(var(--scale) * 314);
    }

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 512);
    }

    h5 {
      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 334);
        padding-left: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 40);
        line-height: 110%;
        letter-spacing: -0.04em;
      }
    }

    p {
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding-left: calc(var(--scale) * 8);
        max-width: calc(var(--scale) * 334);
        font-size: calc(var(--scale) * 18);
      }
    }

    .block__cheap {
      position: absolute;
      top: calc(var(--scale) * 35);
      right: calc(var(--scale) * 25);

      display: flex;
      flex-direction: column;
      align-items: flex-end;

      @include media-down($size-tablet) {
        top: calc(var(--scale) * 33);
        left: calc(var(--scale) * 250);
        right: auto;
      }

      @include media-down($size-tablet) {
        left: auto;
        right: calc(var(--scale) * 5);
      }

      span {
        padding: calc(var(--scale) * 8) calc(var(--scale) * 14) calc(var(--scale) * 10);
        border-radius: calc(var(--scale) * 40);

        font-weight: 400;
        font-size: calc(var(--scale) * 20);
        line-height: 130%;

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 4) calc(var(--scale) * 10) calc(var(--scale) * 6);
          font-weight: 500;
          font-size: calc(var(--scale) * 14);
        }
      }

      span:first-child {
        position: relative;
        z-index: 2;
        background-color: #FFFFFF;
        transform: rotate(-12deg);

        @include media-down($size-tablet) {
          left: calc(-1 * var(--scale) * 4);
        }
      }

      span:last-child {
        transform: rotate(-5deg) translateY(-3px);
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: calc(var(--scale) * 8);

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 334);
        position: absolute;
        right: calc(var(--scale) * 20);
        top: calc(var(--scale) * 28);
      }

      @include media-down($size-tablet) {
        position: static;
        padding-left: calc(var(--scale) * 8);
      }

      li {
        display: flex;
        align-items: center;
        gap: calc(var(--scale) * 12);

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          gap: calc(var(--scale) * 8);

          font-weight: 400;
          font-size: calc(var(--scale) * 16);
          line-height: 130%;
          letter-spacing: -0.02em;
        }

        &:before {
          content: '';
          flex-shrink: 0;
          display: block;
          width: calc(var(--scale) * 12);
          height: calc(var(--scale) * 12);
          background-color: #FFFFFF;
          border-radius: 2px;
        }
      }
    }

    button,
    a {
      margin-top: auto;
      padding: calc(var(--scale) * 44) calc(var(--scale) * 56);
      width: 100%;
      box-shadow:
        calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
      border-radius: calc(var(--scale) * 40);
      transition: 200ms;

      text-align: center;
      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;

      @include media-down($size-tablet) {
        padding-block: calc(var(--scale) * 30);
        border-radius: calc(var(--scale) * 24);
        font-size: calc(var(--scale) * 18);
        letter-spacing: -0.02em;
      }

      @media (hover: hover) {
        &:hover {
          color: #FFFFFF;
        }
      }
    }

    &--blue {
      background-image: url("/v2/school-new/schedule/blue.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/schedule/blue-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/schedule/blue-mob.webp");
      }

      p span {
        color: #0A4183;
      }

      .block__cheap span {
        color: #0A4183;
        background-color: #CEF9FF;
      }

      button,
      a {
        background-color: #CEF9FF;
        color: #0A4183;

        @media (hover: hover) {
          &:hover {
            background-color: #0A4183;
          }
        }
      }
    }

    &--orange {
      background-image: url("/v2/school-new/schedule/orange.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/schedule/orange-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/schedule/orange-mob.webp");
      }

      p span {
        color: #FF5319;
      }

      .block__cheap span {
        color: #FF5319;
        background-color: #FFF0D1;
      }

      button,
      a {
        background-color: #FFF0D1;
        color: #FF5319;

        @media (hover: hover) {
          &:hover {
            background-color: #FF5319;
          }
        }
      }
    }

    &--green {
      background-image: url("/v2/school-new/schedule/green.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/schedule/green-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/schedule/green-mob.webp");
      }

      p span {
        color: #01410D;
      }

      .block__cheap span {
        color: #01410D;
        background-color: #D1FAD8;
      }

      button,
      a {
        background-color: #D1FAD8;
        color: #01410D;

        @media (hover: hover) {
          &:hover {
            background-color: #01410D;
          }
        }
      }
    }

    &--red {
      background-image: url("/v2/school-new/schedule/red.webp");

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/schedule/red-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/schedule/red-mob.webp");
      }

      p span {
        color: #8D1717;
      }

      .block__cheap span {
        color: #8D1717;
        background-color: #FFC8C8;
      }

      button,
      a {
        background-color: #FFC8C8;
        color: #8D1717;

        @media (hover: hover) {
          &:hover {
            background-color: #8D1717;
          }
        }
      }
    }

    &--base {
      background-image: url("/v2/school-new/5/base.webp");

      @include media-down($size-tablet) {
        padding-top: calc(var(--scale) * 10);
        background-image: url("/v2/school-new/5/base-mob.webp");
      }

      h4 {
        font-weight: 500;
        font-size: calc(var(--scale) * 48);
        line-height: 110%;
        letter-spacing: -0.02em;
        color: #02120F;

        @include media-down($size-tablet) {
          max-width: calc(var(--scale) * 334);
          font-size: calc(var(--scale) * 34);
          line-height: 85%;
          letter-spacing: -0.04em;
        }

        span {
          color: #22AE73;
        }
      }

      .block__cheap {
        align-items: flex-start;
        top: calc(var(--scale) * 245);
        left: calc(var(--scale) * 24);
        right: auto;
        transform: rotate(5.22deg);

        @include media-down($size-tablet) {
          top: calc(var(--scale) * 120) !important;
          left: calc(var(--scale) * 12);
        }

        span {
          color: #01410D;
          background-color: #22AE73;

          &:last-of-type {
            color: #ffffff;
          }
        }
      }

      button {
        background-color: #01410D;
        color: #FFFFFF;

        @media (hover: hover) {
          &:hover {
            background-color: #22AE73;
          }
        }
      }
    }

    &--half {
      @include media-down($size-tablet) {
        height: calc(var(--scale) * 366);
        width: calc(var(--scale) * 366);
        border-radius: calc(var(--scale) * 32);
        overflow: hidden;
        gap: 0;

        .block__cheap {
          top: calc(var(--scale) * 8);
          align-items: flex-start;

          span:last-child {
            transform: rotate(-5deg) translateX(-5px);
          }
        }

        h5 {
          margin-bottom: calc(var(--scale) * 4);
          font-size: calc(var(--scale) * 28);
          line-height: 95%;
          letter-spacing: -0.02em;
        }

        p {
          margin-bottom: calc(var(--scale) * 8);
        }

        ul li {
          font-size: calc(var(--scale) * 14);
        }
      }
    }
  }

  &__banner {
    height: calc(var(--scale) * 350);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: calc(var(--scale) * 24) calc(var(--scale) * 40) calc(var(--scale) * 40);

    background-image: url("/v2/school-new/schedule/banner.webp");
    background-size: 100% 100%;

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 366);
      width: calc(var(--scale) * 366);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      background-image: url("/v2/school-new/schedule/banner-tablet.webp");
      position: absolute;
      right: 0;
      bottom: calc(var(--scale) * 8);
      border-radius: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      position: static;
    }

    h5 {
      max-width: calc(var(--scale) * 1200);

      font-weight: 500;
      font-size: calc(var(--scale) * 80);
      line-height: 90%;
      letter-spacing: -0.04em;
      color: #4F0338;

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 334);
        padding-left: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 34);
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      span {
        color: #D524A9;
      }
    }

    button {
      padding: calc(var(--scale) * 34) calc(var(--scale) * 56);
      background-color: #76195A;
      border-radius: calc(var(--scale) * 24);
      transition: 200ms;

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding-block: calc(var(--scale) * 30);
        border-radius: calc(var(--scale) * 24);
        font-size: calc(var(--scale) * 18);
        letter-spacing: -0.02em;
      }

      @include media-down($size-mobile) {
        width: 100%;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #8D1E6C;
        }
      }
    }
  }

  &__prof-class-banner {
    height: calc(var(--scale) * 350);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: calc(var(--scale) * 16) calc(var(--scale) * 40) calc(var(--scale) * 40);

    background-image: url("/v2/school-new/schedule/prof-class-banner.webp");
    background-size: 100% 100%;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      height: calc(var(--scale) * 314);
      background-image: url("/v2/school-new/schedule/prof-class-banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      height: calc(var(--scale) * 512);
      background-image: url("/v2/school-new/schedule/prof-class-banner-mob.webp");
    }

    h5 {
      max-width: calc(var(--scale) * 1289);
      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 496);
        padding-inline: calc(var(--scale) * 8);
        font-size: calc(var(--scale) * 40);
        line-height: 110%;
        letter-spacing: -0.04em;
      }

      span {
        color: #8D176C;

        @include media-down($size-tablet) {
          display: block;
        }
      }
    }

    button {
      padding: calc(var(--scale) * 44) calc(var(--scale) * 56);
      background-color: #8D176C;
      box-shadow:
        calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
      border-radius: calc(var(--scale) * 40);
      transition: 200ms;

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding-block: calc(var(--scale) * 30);
        border-radius: calc(var(--scale) * 24);
        font-size: calc(var(--scale) * 18);
        letter-spacing: -0.02em;
      }

      @include media-down($size-mobile) {
        padding-inline: calc(var(--scale) * 10);
        width: 100%;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #F199CE;
        }
      }
    }
  }
}

</style>
